import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class PlaidService extends AbstractService {
	static setup(baseURL, options) {
		instance = new PlaidService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);

		this.endpoint = APIEndpoints.plaid;
	}

	static exchangeToken(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._exchangeToken(...params);
	}

	static signUpExchangeToken(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._signUpExchangeToken(...params);
	}

	_exchangeToken(data) {
		return this.post({
			endpoint : `${this.endpoint}/exchange`,
			data,
		});
	}

	_signUpExchangeToken(queryParams, data) {
		return this.post({
			endpoint : `${APIEndpoints.signUp}/${this.endpoint}/exchange`,
			queryParams,
			data,
		});
	}
}
